
















import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

@Component
export default class UnsavedDialog extends Vue {
  @Prop({ default: false })
  readonly dialog!: boolean;
}
